import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '../../../../common/components/icon/icon';
import { mediaDataSelector } from '../../../../common/store/selectors/mediaData.selector';
import { toggleClosedCaptions } from '../../../../core/store/actions/mediaData.actions';
import { CONTROLS_ICON_TYPES } from '../../icon/iconMapper';
import { useHoverRef } from '../../../../common/hooks/useHoverRef';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { getClosedCaptionsId } from '../../htmlElements/htmlElementsIdGetter';

const ARIA_LABEL = 'Closed Captions';

const getStyles = (ccButtonHovered: boolean) => ({
  wrapper: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    opacity: ccButtonHovered ? '1' : '0.7',
  },
});

export const ClosedCaptionsButton = () => {
  const isCCTurnedOn = useSelector(mediaDataSelector.isCCTurnedOn);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const dispatch = useDispatch();

  const [ccButtonRef, ccButtonHovered] = useHoverRef();
  const styles = getStyles(ccButtonHovered);

  const onClick = () => {
    dispatch(toggleClosedCaptions(!isCCTurnedOn));
  };

  const closedCaptionsProps = (icon: any) => ({
    icon,
    id: getClosedCaptionsId(playerUniqueId),
    ariaLabel: ARIA_LABEL,
  });

  return (
    <button style={styles.wrapper} onClick={onClick} ref={ccButtonRef} tabIndex={-1} type="button" >
      {
        isCCTurnedOn
          ? <Icon {...closedCaptionsProps(CONTROLS_ICON_TYPES.CC_ON)} /> : <Icon {...closedCaptionsProps(CONTROLS_ICON_TYPES.CC_OFF)} />
      }
    </button>
  );
};
